import { TEDParseNumberMode } from '../FormatterTypes';

import { TEDCustomNumberParser } from './TEDCustomNumberParser';

export class TEDParseInt extends TEDCustomNumberParser {
  public static getInstance(): TEDParseInt {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDParseInt;

  mode(): TEDParseNumberMode {
    return TEDParseNumberMode.pnmInteger;
  }
}
